
































import { Vue, Component, Prop } from 'vue-property-decorator'
import store from 'src/assets/store'
import { StudentGroup } from 'src/graphql/types'

@Component
export default class ItemCourseStudentGroupSelectBar extends Vue {
  state = store.state

  @Prop()
  readonly attendeeCount!: number

  @Prop()
  readonly group!: StudentGroup

  @Prop()
  readonly groups!: StudentGroup[]
}
